import React from 'react';
import styles from './index.module.less';
import { Modal, Button, ConfigProvider } from 'antd';

interface IProps {
    handleClose: () => void;
}

function ExpiredExplainModal(props: IProps) {
    return (
        <ConfigProvider
            theme={{
                token: {
                    colorPrimary: '#rgba(255, 145, 62, 1)',
                    borderRadius: 8,
                },
            }}
        >
            <Modal
                wrapClassName={styles['expired-explain-modal-wrap']}
                title="说明"
                width={450}
                open={true}
                centered
                footer={
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button style={{ width: 240 }} onClick={() => props.handleClose()} type="primary">
                            知道啦
                        </Button>
                    </div>
                }
                onOk={() => props.handleClose()}
                onCancel={() => props.handleClose()}
            >
                <div className={styles['content']}>
                    系统课仅展示2022年1月1日后到期的课程，更早的到期课程请前往【个人中心-我的订单】中查询订单后咨询学管老师
                </div>
                <div className={styles['sub-content']}>
                    注：冻结订单的课程不会展示在到期课程中。若想提前解冻订单，请前往【个人中心-我的订单-冻结订单】中申请提前解冻
                </div>
            </Modal>
        </ConfigProvider>
    );
}

export default ExpiredExplainModal;
